export default "__VITE_ASSET__CVgLf4a7__"